import React, { ReactElement } from 'react';
import MainRankingsButton from 'components/main/rankings/button/main-rankings-button';

interface MainRankingsButtonGroupProps {
    next?: () => void;
    previous?: () => void;
}

const MainRankingsButtonGroup: React.FC<MainRankingsButtonGroupProps> = ({ next, previous }): ReactElement => (
    <div className="main-rankings__button-group">
        <MainRankingsButton
            direction="left"
            onClick={(): void => {
                if (previous) {
                    previous();
                }
            }}
        />
        <MainRankingsButton
            direction="right"
            onClick={(): void => {
                if (next) {
                    next();
                }
            }}
        />
    </div>
);

export default MainRankingsButtonGroup;
